import type { CustomLabelsByField } from '../../state/domain/custom-labels/types.tsx';
import type { State } from '../../state/types.tsx';

export const getCustomLabelsByField = (state: State): CustomLabelsByField =>
	state.domain.customLabelsByField;
